import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { RoleEntity } from '../../domain/entities/RoleEntity'
import type { RoleDto } from '@/backend/market'

export class RoleModel extends RoleEntity {
  constructor(dataDto: RoleDto) {
    super()
    mapEntityProperties<RoleEntity>(this, dataDto)
  }
}
